<template>
  <v-container id="support-container" class="support-container">
    <div class="maintitle">
      {{ $t("Home.Support.title") }}
    </div>
    <v-row>
      <v-col cols="12" sm="4" class="firstcol">
        <div class="img"></div>
        <div class="description">
          <span>{{ $t("Home.Support.description") }}</span>
        </div>
      </v-col>

      <v-col cols="12" sm="8" class="data-col">
        <v-container class="data">
          <div v-if="showData">
            <userdata></userdata>
          </div>
          <div v-if="showRequest">
            <v-row class="secondrow">
              <v-col>
                <div class="maintitle request">{{ $t("Support.request") }}</div>
                <div class="textarea">
                  <v-textarea
                    v-model="request"
                    no-resize
                    single-line
                    :label="$t('Support.hint')"
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>
            <v-row class="requestrow">
              <v-col cols="12" sm="6" class="requestcol">
                <v-checkbox v-model="term">
                  <template v-slot:label>
                    <div>
                      <v-tooltip>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            :href="privacyUrl"
                            @click.stop
                            v-on="on"
                          >
                            {{ $t("Misc.term") }}
                          </a>
                        </template>
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
                <div>
                  <img v-if="term_warning" src="@/assets/info_red.png" />
                </div>
              </v-col>
              <v-col cols="12" sm="6" style="position: relative">
                <v-btn class="generic-button send-btn" @click="sendRequest()">
                  {{ $t("Misc.send") }}
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div class="email-sent" v-if="showSuccess">
            <v-row>
              <v-col cols="12" class="img-container">
                <img src="@/assets/check_Tavola.png" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="msg-container">
                {{ $t("Support.request_sent") }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="btn-container">
                <v-btn class="generic-button" @click="clearRequest()">
                  {{ $t("Misc.send_another_request") }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
.support-container {
  padding: 100px 12px 40px 12px !important;
  font-size: none !important;
}

.support-container .maintitle {
  letter-spacing: 0px !important;
  color: #5d6367 !important;
}

.support-container .img {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../assets/support.png");
  height: 300px;
  border-radius: 40px;
  box-shadow: 10px 10px 16px #6f767ab3;
}

.support-container .v-input__control {
  font: normal normal normal 20px/24px Roboto;
  padding: 0 30px 0 30px;
  color: #707070 !important;
}

.support-container .secondrow {
  padding: 0 32px 0 32px;
}

.support-container .maintitle.request {
  padding-left: 30px !important;
}

.support-container .requestrow {
  padding-left: 42px;
}

.support-container .theme--light.v-input:not(.v-input--is-disabled) textarea,
.support-container .v-label.theme--light {
  font: normal normal bold 20px/24px Roboto;
  color: #707070;
  height: 100% !important;
}

.support-container .email-sent img {
  height: 150px;
}

.support-container .email-sent {
  padding: 130px 0 150px 0;
}

.support-container .btn-container {
  padding-top: 40px;
}

.support-container .email-sent .img-container,
.support-container .email-sent .btn-container,
.support-container .email-sent .msg-container {
  text-align: center;
}

.support-container .requestcol .v-label.theme--light {
  text-decoration: underline;
  font: normal normal normal 16px/19px Lato;
}

.support-container .description {
  font: normal normal bold 30px/36px Lato;
  letter-spacing: 0px;
  color: #6f767a;
  text-align: center;
  margin-top: 27px;
}

.support-container .data {
  box-shadow: 8px 9px 16px #00000029;
  background-color: white;
  color: #707070;
  border-radius: 40px;
  font: normal normal bold 20px/24px Roboto !important;
}

.support-container .textarea {
  background-color: #6f767a4d;
  border-radius: 40px;
  height: 245px;
}

.support-container .v-text-field > .v-input__control > .v-input__slot:before,
.support-container .v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}

.support-container .requestrow img {
  margin-top: 22px;
  height: 20px;
}

.support-container .requestcol {
  display: flex;
}

/* .support-container .text div {
  padding-top: 10px;
} */

.support-container .text span {
  margin-right: 12px;
}

.support-container .userdata-container {
  box-shadow: none;
}

.support-container .userdata-container .support-nation-div,
.support-container .userdata-container .support-phone-div {
  display: block;
}

.support-container .userdata-container .nation-col {
  display: none;
}

.support-container .userdata-container .first-col,
.support-container .userdata-container .company-col {
  flex: 0 0 50%;
  max-width: 50%;
}

.support-container .userdata-container .first-col {
  padding-left: 0;
}

.support-container .userdata-container .firstrow {
  padding: 30px 75px 0 75px;
}

.support-container .data-col {
  padding-left: 69px;
}

.support-container .container.data .maintitle {
  margin-top: 0;
}

.support-container .container.data .send-btn {
  position: absolute;
  right: 45px;
  top: 50%;
  transform: translateY(-50%);
}

@media (max-width: 600px) {
  .support-container .firstcol {
    display: none;
  }

  .support-container .data-col {
    padding-left: 0px;
    padding-right: 0;
  }

  .support-container .data {
    font: normal normal bold 15px Roboto !important;
  }

  .support-container .v-input__control {
    font: normal normal normal 15px Roboto;
  }

  .support-container .firstrow {
    padding: 14px 4px 0 4px;
  }

  .support-container .firstrow .companyrow {
    border-top: 2px solid #6f767a;
  }

  .support-container .firstrow .companyrow .text {
    padding-left: 10px;
  }

  .support-container .secondrow {
    padding: 0;
  }

  .support-container .maintitle.request {
    display: none;
  }

  .support-container .requestcol {
    padding: 0 !important;
  }

  .support-container .requestcol .v-label.theme--light {
    font-size: 14px !important;
  }

  .support-container .textarea {
    border-radius: 20px;
    height: 300px;
  }

  .support-container .data {
    border-radius: 20px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 0px;
  }

  .support-container .theme--light.v-input:not(.v-input--is-disabled) textarea,
  .support-container .v-label.theme--light {
    font: normal normal normal 15px Roboto;
    color: #707070;
    height: 100% !important;
  }

  .support-container .email-sent img {
    height: 150px;
  }

  .support-container .email-sent .msg-container {
    padding: 16px 16px 40px 16px;
  }

  .support-container .email-sent .btn-container {
    padding-bottom: 40px;
  }

  .support-container .userdata-container .first-col,
  .support-container .userdata-container .company-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .support-container .userdata-container .firstrow {
    padding: 0;
  }

  .support-container .userdata-container .firstrow .company-col {
    padding-left: 0;
    padding-right: 0;
  }

  .support-container .userdata-container .firstrow .bar-div {
    padding-top: 16px;
  }

  .support-container .userdata-container {
    padding-bottom: 0;
  }

  .support-container .userdata-container .firstrow {
    margin-bottom: 0;
  }

  .support-container .requestrow {
    padding-left: 0;
  }

  .support-container .v-input__control {
    padding: 0 0 0 16px;
  }

  .support-container .requestrow .v-input__control {
    padding: 0 0 0 0px;
  }

  .support-container .row {
    margin-left: 0;
    margin-right: 0;
  }

  .support-container .secondrow .col {
    padding-left: 0;
    padding-right: 0;
  }

  .support-container .container.data .send-btn {
    position: absolute;
    right: 0px;
  }

  .support-container .userdata-container .bar-div {
    width: 325px;
  }
}
</style>
<script>
import loading from "../components/loadingComponent.vue";
import { Trans } from "@/plugins/Translation";
import MDApi from "../api/MD/MDApi.js";
import EmailSenderApi from "../api/EmailSender/EmailSenderApi.js";
import userdata from "../components/userData.vue";

export default {
  components: {
    loading,
    userdata,
  },

  data() {
    return {
      reference_data: {
        name: "",
        surname: "",
        email: "",
      },
      company_data: {
        name: "",
        street: "",
        zipcode: "",
        locality: "",
        nation: "",
        companyCode: "",
      },
      privacyUrl: process.env.VUE_APP_PRIVACY_URL,
      request: "",
      term: false,
      term_warning: false,
      mail_sent: false,
      isMobile: false,
      showData: true,
      showSuccess: false,
      showRequest: true,
    };
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();
    //  let a = this.$vuetify.breakpoint.width;
    //    console.log("a", a);
    this.closeMenu();

    this.user = this.$GAUserAuth.user;
    this.reference_data.name = this.user.firstname;
    this.reference_data.surname = this.user.lastname;
    this.reference_data.email = this.user.username;

    let companyCode = this.user.companyCode;

    MDApi.GetCompanyData(companyCode).then((res) => {
      if (res.data) {
        this.company_data.name = res.data.Name;
        this.company_data.street = res.data.Address;
        this.company_data.zipcode = res.data.ZipCode;
        this.company_data.locality = res.data.City;
        this.company_data.nation = res.data.CountryDescription;
        this.company_data.phone = res.data.AccountingPhone;
        this.company_data.companyCode = res.data.AltKN;
      }
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    myEventHandler(e) {
      this.setIsMobile();
    },
    clearRequest() {
      this.showData = true;
      this.showSuccess = false;
      this.showRequest = true;
      this.request = "";
      this.term_warning = false;
      this.term = false;
    },
    sendRequest() {
      if (!this.term) {
        this.term_warning = true;
        return;
      }

      if (!this.request) {
        // console.log("Empty request");
        return;
      }

      let message = Trans.i18n
        .t("Email.Support.Message")
        .replace(
          "{0}",
          this.reference_data.name +
            " " +
            this.reference_data.surname +
            " (" +
            this.reference_data.email +
            ", " +
            this.company_data.companyCode +
            ", " +
            this.company_data.name +
            ") "
        )
        .replace("{1}", this.request);

      EmailSenderApi.SendMail(
        Trans.i18n.t("Email.Support.Subject"),
        [process.env.VUE_APP_EMAIL_RECIPIENT],
        null,
        message
      ).then((res) => {
        if (res.data) {
          this.showSuccessDiv();
        }
      });
    },
    showSuccessDiv() {
      if (!this.isMobile) this.showData = false;
      else this.showData = true;

      this.showRequest = false;

      this.showSuccess = true;
      this.request = "";
      this.term_warning = false;
      this.term = false;
      this.mail_sent = true;
    },
    closeMenu() {
      let showSM = {
        show: false,
        style: "color: #cecece",
      };

      this.$store.commit("SET_showSearchMenu", showSM);
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
  },
};
</script>
